import { z } from 'zod';
import { STATS_TYPE } from '#schemas/config-override/helpers/enums.ts';

export const statsTypeRequiredSchema = z.enum(STATS_TYPE, {
  errorMap: (error, ctx) => {
    if (error.code === z.ZodIssueCode.invalid_enum_value && error.received === '') {
      return { message: 'Choose a stats type' };
    }
    return { message: ctx.defaultError };
  },
});
